import React from 'react';
import {connect} from 'react-redux';
import {Map, List} from 'immutable';
import BookingInput from '../BookingInput/BookingInput';
import {sessionCache} from 'locache';
import * as actionCreators from './actions';
import bowser from 'bowser';
import moment from 'moment';
import PartyDetails from '../PartyDetails/PartyDetails';
import {Provider} from 'react-redux';
import {DateRangePicker, SingleDatePicker} from 'react-dates';
import 'react-dates/initialize';
import PartyDetailsOverlay from '../PartyDetails/PartyDetailsOverlay';
import togglePageScroll from '../../modules/togglePageScroll';
import InformationTooltip from '../InformationTooltip/InformationTooltip';
import request from 'superagent';

export class BookingForm extends React.Component {

  constructor(props) {
    console.log(props);
    super();
    const guid = btoa(Math.random() * 1000000);
    this.state = {
      ...props,
      userAgent: bowser,
      formRef: React.createRef(),
      guid
    };
    moment.locale('en-gb');
  }

  componentDidMount() {
    //this.props.setStateFromJson(this.props.initialData);
    if (this.props.preselectedRegion) {
      this.props.updateTextField('regions', this.props.preselectedRegion);
    }
    if (this.props.preselectedResort) {
      this.props.updateTextField('resorts', this.props.preselectedResort);
    }
    if (this.props.preselectedAccommodation) {
      const nextMap = this.props.accommodation.find(x => x.get('name', '') === this.props.preselectedAccommodation) || Map({});
      const accommodationInList = nextMap.count() > 0;
      if (accommodationInList) {
        this.props.updateTextField('accommodation', this.props.preselectedAccommodation);
      }
    }
  }

  isDayBlocked(day) {
    if (this.props.duration === 'Other') {
      return (day.isAfter(this.props.seasonEndDate) || day.isBefore(this.props.seasonStartDate)) && (day.isAfter(this.props.nextSeasonEnd) || day.isBefore(this.props.nextSeasonStart));
    }

    if (moment.weekdays(day.weekday()) !== 'Saturday') {
      return true;
    }

    if (day.isBefore(this.props.thisSeasonStart)) {
      return true;
    }

    if (day.isAfter(this.props.nextSeasonEnd)) {
      return true;
    }

    return !!(day.isAfter(this.props.thisSeasonEnd) && day.isBefore(this.props.nextSeasonStart));
  }

  render() {
    const isMs = this.state.userAgent.msie || this.state.userAgent.msedge;
    return (
      <div className={'booking-form'}>
        <form ref={this.state.formRef} action={'/umbraco/surface/AvailabilitySearch/Submit'} method={'get'}
              onSubmit={e => {
                e.preventDefault();
                e.persist();
                e.preventDefault();
                /*e.preventDefault();
                e.stopPropagation();*/
                if (!this.state.submitReady) {

                  if (this.props.duration === 'Other' && this.props.endDate === null) {
                    document.getElementById('end-date-entry').focus();
                    return;
                  }

                  const bookingLoader = document.getElementsByClassName('booking-loader');
                  if (bookingLoader.length > 0) {
                    bookingLoader[0].classList.add('--visible');
                    togglePageScroll(true);
                  }
                  e.preventDefault();
                  this.setState({submitReady: true});
                  setTimeout(() => {

                    sessionCache('partyDetails').set(JSON.stringify(this.props.partyDetails.toJS()));
                    //sessionCache('bookingInputFields').set(JSON.stringify(this.props.inputFields.toJS()));
                    sessionCache('endDate').set(this.props.endDate !== null ? this.props.endDate.format('DD/MM/YYYY') : null);
                    sessionCache('duration').set(this.props.duration);
                    sessionCache('bookingDate').set(this.state.selectedDate.format('DD/MM/YYYY'));
                    sessionCache('scanDays').set(this.props.scanDays);
                    sessionCache('bookingRegion').set(this.props.inputFields.getIn(['regions', 'value']));
                    sessionCache('bookingResort').set(this.props.inputFields.getIn(['resorts', 'value']));
                    sessionCache('bookingAccommodation').set(this.props.inputFields.getIn(['accommodation', 'value']));
                    e.target.submit();
                  }, 200);
                }
                this.props.updateDiamondAndAvailproCodes();
              }}>
          <div className={`booking-form__tab${this.props.premium ? ' --premium' : ''}${isMs ? ' --no-clip' : ''}`}>{this.props.title}
          </div>
          {this.props.inputFields.entrySeq().map(([key, value]) => {
            return (
              <div className={'booking-form__input-row'} key={key}>
                <BookingInput name={key} entries={this.props[key]}/>
              </div>
            );
          })}


          <div className={'booking-form__input-row'}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <label style={{ float: 'left' }} htmlFor="booking-form-length-of-stay" className={'booking-form__label'}>Length of stay <div
                className={'booking-form__information-popup-container'}>

                {<InformationTooltip
                  text={'Our apartments are mostly Saturday to Saturday. For other durations, we also offer a range of hotels'}/>}

              </div></label>
            </div>
            <select id="booking-form-length-of-stay" value={this.props.duration} onChange={e => this.props.changeDurationValue(e.target.value)}
              className={'input booking-form__input'} name={'nights'}>
              <option disabled defaultValue>Please select</option>
              <option value={'7'}>7 nights (Saturday to Saturday)</option>
              {<option value={'Other'}>Other durations</option>}
            </select>
          </div>


          {(this.props.duration === '7' || this.props.duration === 'Other') && <div className={'booking-form__input-row'}>
            <label className={'booking-form__label'}
                   htmlFor={'booking-form__arrival-date'}>Arrival{this.props.duration === 'Other' ? '/Departure ' : ' '}
              date</label>
            <input type={'hidden'} name={'arrivalDate'}
              value={this.state.selectedDate.format('DD/MM/YYYY')} />

            <input type={'hidden'} name={'arrivalDateString'}
              value={this.state.selectedDate.format('DD/MMM/YYYY')} />

            <input type={'hidden'} name={'arrivalDateDay'}
              value={this.state.selectedDate.format('DD')} />

            <input type={'hidden'} name={'arrivalDateMonth'}
              value={this.state.selectedDate.format('MMM')} />

            <input type={'hidden'} name={'arrivalDateYear'}
              value={this.state.selectedDate.format('YYYY')} />

            {this.props.duration === 'Other' ? <input type={'hidden'} name={'Nights'}
              value={moment(this.state.endDate).diff(moment(this.state.selectedDate), 'days')} /> : null}

            <input type={'hidden'} name={'season'}
              value={this.state.season} />
            <input type={'hidden'} name={'Searchtype'}
              value={this.props.duration === 'Other' ? 'Availpro' : 'Diamond' } />
            <div>
              {this.props.duration === 'Other' ?
                <DateRangePicker isDayBlocked={this.isDayBlocked.bind(this)}
                                 noBorder={true}
                                 readOnly={true}
                                 startDateId={'start-date-entry'}
                                 endDateId={'end-date-entry'}
                                 startDate={this.props.selectedDate}
                                 endDate={this.props.endDate}
                                 onFocusChange={(focusedInput) => this.setState({focusedInput})}
                                 focusedInput={this.state.focusedInput} // PropTypes.bool
                                 onDatesChange={({startDate, endDate}) => {
                                   this.setState({ selectedDate: startDate, endDate });

                                   this.props.updateDate(startDate, endDate);
                                 }} // PropTypes.func.isRequired
                  displayFormat={'DD/MM/YYYY'}
                  numberOfMonths={1}
                                 required/> :
                <SingleDatePicker
                  date={this.state.selectedDate} // momentPropTypes.momentObj or null
                  onDateChange={date => {
                    this.setState({ selectedDate: date });
                    this.props.updateDate(date);
                  }} // PropTypes.func.isRequired
                  focused={this.state.focused} // PropTypes.bool
                  numberOfMonths={1}
                  firstDayOfWeek={1}
                  noBorder={true}
                  readOnly={true}
                  isDayBlocked={this.isDayBlocked.bind(this)}
                  displayFormat={'dddd Do MMMM YYYY'}
                  onFocusChange={({focused}) => this.setState({focused})} // PropTypes.func.isRequired
                  id={'booking-form__arrival-date'} // PropTypes.string.isRequired,
                  required
                />}

              
            </div>
          </div>}

          {this.props.duration === 'Other' ?
            <div className={'booking-form__input-row'}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <label style={{ float: 'left' }} className={'booking-form__label'}>Arrival date flexibility<div
                  className={'booking-form__information-popup-container'}>
                </div></label>
              </div>
              <select value={this.props.scanDays} name={'scanDays'} onChange={e => this.props.changeScanDaysValue(parseInt(e.target.value))}
                className={'input booking-form__input'}>
                <option value={0}>none</option>
                <option value={1}>+/- 1 day</option>
                <option value={2}>+/- 2 days</option>
                <option value={3}>+/- 3 days</option>
              </select>
            </div> : ''}

          <div className={'booking-form__input-row'}>
            <label htmlFor="party-details-makeup" className={'booking-form__label --larger'}>Party details</label>
            <PartyDetails/>
          </div>

          <input type={'hidden'} value={this.props.availproRegionCode} name={'AvailproRegionCode'}/>
          <input type={'hidden'} value={this.props.regionNodeId} name={'RegionNodeId'}/>
          <input type={'hidden'} value={this.state.guid} name={'guid'}/>
          <input type={'hidden'} value={this.props.diamondRegionCode} name={'DiamondRegionCode'}/>
          <input type={'hidden'} value={this.props.availproResortCode} name={'AvailproResortCode'}/>
          <input type={'hidden'} value={this.props.diamondResortCode} name={'DiamondResortCode'}/>
          <input type={'hidden'} value={this.props.resortNodeId} name={'ResortNodeId'}/>
          <input type={'hidden'} value={this.props.accommodationNodeId} name={'AccommodationNodeId'}/>
          <input type={'hidden'} value={this.props.availproAccommodationCode}
                 name={'AvailproAccommodationCode'}/>
          <input type={'hidden'} value={this.props.diamondAccommodationCode}
                 name={'DiamondAccommodationCode'}/>

          {this.props.adultCounts.map((num, index) => <input type={'hidden'} name={`Rooms[${index}].Adults`}
                                                             value={num} key={index}/>)}
          {this.props.childCounts.map((num, index) => <input type={'hidden'} name={`Rooms[${index}].Children`}
                                                             value={num} key={index}/>)}
          {this.props.childAges.map((room, index) => room.map((child, index2) => <input type={'hidden'}
                                                                                        name={`Rooms[${index}].ChildAge[${index2}]`}
                                                                                        value={child}
                                                                                        key={`${index}+${index2}`}/>))}
          <div>
            <input type={'hidden'} name={'NumberOfRooms'} value={this.props.numberOfRooms}/>
          </div>
          {this.props.duration !== 'Please select' && <div className={'booking-form__input-row'}>
            <button type={'submit'} className={'button --no-margin'}><span className={'button__text'}>Check availability or book online</span>
            </button>
          </div>}

        </form>
      </div>
    );
  }
}

export default connect((stateMap, ownProps) => {

  const preselectedRegion = ownProps.preselectedRegion;
  const altArrivalDateMessage = ownProps.altArrivalDateMessage;
  const preselectedResort = ownProps.preselectedResort;
  const preselectedAccommodation = ownProps.preselectedAccommodation;
  const showAlternativeArrivalDates = ownProps.showAlternativeArrivalDates;
  const telephoneNumber = ownProps.telephoneNumber;
  const partyDetails = stateMap.get('partyDetails', Map({}));
  const state = stateMap.get('bookingForm', Map({}));
  const numberOfRooms = stateMap.getIn(['partyDetails', 'numberOfRooms'], 1);

  const inputFields = state.get('inputFields', Map({}));
  const regionValue = inputFields.getIn(['regions', 'value'], null);
  const resortValue = inputFields.getIn(['resorts', 'value'], null);
  const seasonStartDate = moment(state.get('seasonStartDate'), 'DD/MM/YYYY');
  const selectedDate = state.get('selectedDate');
  const scanDays = state.get('scanDays', 0);
  const endDate = state.get('endDate', null);
  const seasonEndDate = moment(state.get('seasonEndDate'), 'DD/MM/YYYY');
  const availproAccommodationCode = state.getIn(['inputFields', 'accommodation', 'availproCode'], '');
  const diamondAccommodationCode = state.getIn(['inputFields', 'accommodation', 'diamondCode'], '');
  const availproResortCode = state.getIn(['inputFields', 'resorts', 'availproCode'], '');
  const diamondResortCode = state.getIn(['inputFields', 'resorts', 'diamondCode'], '');
  const availproRegionCode = state.getIn(['inputFields', 'regions', 'availproCode'], '');
  const diamondRegionCode = state.getIn(['inputFields', 'regions', 'diamondCode'], '');
  const regionNodeId = state.getIn(['inputFields', 'regions', 'nodeId'], '');
  const resortNodeId = state.getIn(['inputFields', 'resorts', 'nodeId'], '');
  const accommodationNodeId = state.getIn(['inputFields', 'accommodation', 'nodeId'], '');
  const duration = state.get('duration', 'Please select');
  const premium = ownProps.premium;

  let regions = state.get('regions', Map({}));
  let resorts = Map({});
  let accommodation = Map({});

  const regionMatch = regions.find((value) => {
    return value.get('name') === regionValue;
  }, null, null);

  if (regionMatch !== null) {
    regions = Map({regionMatch});
  }

  //loop through regions and add children resorts
  regions.entrySeq().forEach(([key, value]) => {
    const resortList = value.get('resorts');
    resortList.entrySeq().forEach(([key, value]) => {
      resorts = resorts.set(key, value);
    });
  });


  const resortMatch = resorts.find((value) => {
    return value.get('name') === resortValue;
  }, null, null);

  if (resortMatch !== null) {
    resorts = Map({resortMatch});
  }

  const rooms = stateMap.getIn(['partyDetails', 'rooms'], List([]));
  const adultCounts = rooms.map(room => room.get('adults'));

  const childCounts = rooms.map(room => room.get('children'));
  const hasChildren = rooms.some(room => room.get('children') > 0);

  const childAges = hasChildren ? rooms.map(room => room.get('childAges', List([])).map(child => child !== undefined ? child.get('age') : 0)) : List([]);

  resorts.entrySeq().forEach(([key, value]) => {
    value.get('accommodation').entrySeq().forEach(([key, value]) => {
      accommodation = accommodation.set(key, value);
    });
  });

  const thisSeasonStart = moment(ownProps.thisSeasonStartDate, 'DD/MM/YYYY');
  const thisSeasonEnd = moment(ownProps.thisSeasonEndDate, 'DD/MM/YYYY');
  const nextSeasonStart = moment(ownProps.nextSeasonStartDate, 'DD/MM/YYYY');
  const nextSeasonEnd = moment(ownProps.nextSeasonEndDate, 'DD/MM/YYYY');

  return {
    initialData: ownProps.initialData,
    thisSeasonStart,
    thisSeasonEnd,
    nextSeasonStart,
    duration,
    nextSeasonEnd,
    regions,
    preselectedRegion,
    preselectedResort,
    showAlternativeArrivalDates,
    altArrivalDateMessage,
    adultCounts,
    childCounts,
    childAges,
    numberOfRooms,
    partyDetails,
    preselectedAccommodation,
    resorts,
    accommodation,
    telephoneNumber,
    seasonStartDate,
    seasonEndDate,
    selectedDate,
    scanDays,
    endDate,
    regionNodeId,
    resortNodeId,
    accommodationNodeId,
    inputFields,
    availproRegionCode,
    diamondRegionCode,
    availproResortCode,
    diamondResortCode,
    availproAccommodationCode,
    diamondAccommodationCode,
    premium
  };
}, actionCreators)(BookingForm);
